<template>
  <router-view />
</template>

<script>
export default {
  name: 'History',
  data() {
    return {};
  },
  mounted() {
    this.$store.dispatch('setDrawerStateAction', true);
  },
};
</script>

<style scoped>
.history_container {
  height: calc(100vh - 130px);
  overflow-y: auto;
}
</style>
